module.exports = __webpack_public_path__ + "static/media/Apply.ce972b5c.png";